<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.13 36.3">
    <g id="Capa_2" data-name="Capa 2">
      <g id="Capa_1-2" data-name="Capa 1">
        <path
          d="M17.13,12v.18l-.77,5.95H11.3V36.3H3.83c0-.33-.11-.65-.12-1l0-16.12v-1H0V12H3.71c0-1.93,0-3.71,0-5.48C3.83,3,5.65.67,9.15.2a70.66,70.66,0,0,1,8-.17V6.19a8.06,8.06,0,0,1-1,.13c-1,0-2.06,0-3.09,0a1.55,1.55,0,0,0-1.7,1.33c-.13,1.39,0,2.8,0,4.34Z"
          class="cls-1"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "FacebookSvg",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.cls-1 {
  fill: #fff;
}
</style>
